<div class="chart-wrapper">
    <div class="base-chart" [id]="'chart_' + componentKey" #chart>

    </div>
</div>